export const isLoggedIn = state => !!state.accessToken;
export const isSetupCompleted = (state, getters) => {
	if (!state.currentUser) return false;

	return (
		getters.isSetupCompletedFirstPart
		&& getters.isSetupCompletedSecondPart
	);
};

export const isSetupCompletedFirstPart = (state) => {
	if (!state.currentUser) return false;

	const fields = [
		state.currentUser.lastName,
		state.currentUser.firstName,
		state.currentUser.company,
		state.currentUser.streetAddress,
		state.currentUser.zipCode,
		state.currentUser.city,
		state.currentUser.privacyUrl,
		state.currentUser.imprintUrl,
		state.currentUser.subscriptionStatus !== 'canceled',
	];

	return fields.every(Boolean);
};

export const isSetupCompletedSecondPart = (state) => {
	if (!state.currentUser) return false;

	const fields = [
		state.currentUser.billingAddress.company,
		state.currentUser.billingAddress.streetAddress,
		state.currentUser.billingAddress.zipCode,
		state.currentUser.billingAddress.city,
		state.currentUser.subscriptionStatus === 'active'
		|| state.currentUser.subscriptionStatus === 'past_due'
		|| state.currentUser.subscriptionStatus === 'unpaid'
		|| state.currentUser.subscriptionStatus === 'testing',
	];

	return fields.every(Boolean);
};

export const isPaying = (state) => {
	if (!state.currentUser) return false;

	return (
		state.currentUser.subscriptionStatus === 'active'
		|| state.currentUser.subscriptionStatus === 'past_due'
		|| state.currentUser.subscriptionStatus === 'unpaid'
		|| state.currentUser.subscriptionStatus === 'testing'
	);
};

export const isAdmin = (state) => {
	if (!state.currentUser) return false;

	return !!state.currentUser.isAdmin;
};
